import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import api, { fileUrl } from "../lib/api";
import { ShieldCheck } from "lucide-react";

export default function CountryPage() {
  const { country } = useParams();
  const decoded = decodeURIComponent(country);
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    document.title = `Top football talent from ${decoded} · AfriGoall`;
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = `Discover verified football players from ${decoded}. Scouting-grade profiles, video highlights, and physical stats on AfriGoall.`;
    api.get("/players", { params: { country: decoded } }).then((r) => setPlayers(r.data));
  }, [decoded]);

  return (
    <div className="min-h-screen bg-black text-white grain">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="text-xs uppercase tracking-[0.3em] text-[#e65f2b]">Country</div>
        <h1 className="mt-2 font-display text-5xl font-bold uppercase tracking-tight" data-testid="country-title">Top talent · {decoded}</h1>
        <p className="mt-3 text-white/70">{players.length} players from {decoded}. Verified profiles first.</p>

        <div className="mt-8 grid md:grid-cols-3 lg:grid-cols-4 gap-4">
          {players.map((p) => (
            <Link key={p.user_id} to={`/players/${p.user_id}`} data-testid={`country-card-${p.user_id}`}>
              <div className="border border-white/10 bg-[#141414] hover:border-[#e65f2b] transition-colors">
                <div className="aspect-[4/5] bg-black relative overflow-hidden">
                  {p.photo_path
                    ? <img src={fileUrl(p.photo_path)} alt={p.name} className="w-full h-full object-cover" />
                    : <div className="w-full h-full bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] flex items-center justify-center font-display text-6xl text-white/20">{(p.name || "?")[0]}</div>}
                  {p.verified && (
                    <div className="absolute top-3 right-3 bg-[#eab308] text-black px-2 py-1 text-xs font-bold uppercase tracking-widest flex items-center gap-1">
                      <ShieldCheck size={12} />Verified
                    </div>
                  )}
                  {p.national_team_eligible && (
                    <div className="absolute top-3 left-3 bg-[#2A9D8F] text-black px-2 py-1 text-xs font-bold uppercase tracking-widest">
                      Nat. Team
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <div className="font-display text-lg font-bold uppercase truncate">{p.name}</div>
                  <div className="text-xs text-white/70 uppercase tracking-widest mt-2">{p.position || "—"} · {p.age ? `${p.age}y` : "—"}</div>
                </div>
              </div>
            </Link>
          ))}
          {players.length === 0 && <div className="text-white/50 md:col-span-4">No players from {decoded} yet.</div>}
        </div>
      </div>
      <Footer />
    </div>
  );
}
